// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeContent from "./HomeContent.re.mjs";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as MadeInUSASection from "./MadeInUSASection.re.mjs";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptRelay_Fragment from "rescript-relay/src/RescriptRelay_Fragment.re.mjs";
import * as RescriptRelay_TestFragmentRef from "rescript-relay/src/RescriptRelay_TestFragmentRef.re.mjs";
import * as HomeAmericanOrders_query_graphql from "../../../__generated__/HomeAmericanOrders_query_graphql.re.mjs";

import { t } from '@lingui/macro'
;

let convertFragment = HomeAmericanOrders_query_graphql.Internal.convertFragment;

function fromData(data) {
  return RescriptRelay_TestFragmentRef.make("HomeAmericanOrders_query", data);
}

let Test = {
  fromData: fromData
};

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, HomeAmericanOrders_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(HomeAmericanOrders_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, HomeAmericanOrders_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(HomeAmericanOrders_query_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  Test: Test,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function HomeAmericanOrders(props) {
  let data = RescriptRelay_Fragment.useFragment(HomeAmericanOrders_query_graphql.node, convertFragment, props.query);
  let pieces = Stdlib_Array.filterMap(data.americanOrders, item => {
    let match = item.url;
    let match$1 = item.sku;
    if (match === undefined) {
      return;
    }
    if (match$1 === undefined) {
      return;
    }
    let medium = HomeContent.mediumLabel(match$1);
    return {
      id: item.id,
      src: match,
      alt: t`${medium} made in America from a customer photo`,
      link: HomeContent.orderLink(match$1, item.id),
      title: medium,
      subtitle: t`Made in USA · Custom order`
    };
  });
  return JsxRuntime.jsx(MadeInUSASection.make, {
    pieces: pieces
  });
}

let make = HomeAmericanOrders;

export {
  Fragment,
  make,
}
/*  Not a pure module */
